import { CloseIcon } from "@chakra-ui/icons";
import {
  Button,
  Flex,
  FormLabel,
  Grid,
  GridItem,
  IconButton,
  Input,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Select as ChakraSelect,
  Text,
  Textarea,
  Box,
  Image,
} from "@chakra-ui/react";
import { CUIAutoComplete } from "chakra-ui-autocomplete";
import * as yup from "yup";
import MultiContactModel from "common/components/commonTableModel/MultiContactModel";
import MultiLeadModel from "common/components/commonTableModel/MultiLeadModel";
import Spinner from "common/components/spinner/Spinner";
import { useFormik } from "formik";
import { useState, useEffect } from "react";
import { toast } from "react-toastify";
import { putApi, getApi } from "common/services/api";
import Select from "react-select"; // Importing react-select

import { constant } from "common/constant";
import { globalStyles } from "common/theme/styles";
import { crmConstant } from "services/Crm/constant";
import { formatTimestamp } from "common/utils/dateFormater";
import colors from "common/theme/foundations/colors";
import { MeetingSchema } from "common/schema";
import { convertUtcToIst } from "services/Crm/utils/calcUtils";
import WhiteEditIcon from "common/assets/img/whiteEditIcon.png";
import { EditMeetingSchema } from "common/schema/meetingSchema";
import { useDispatch } from "react-redux";
import { getContactList } from "common/redux/reducers/contactLeadSlice";
import { getLeadList } from "common/redux/reducers/contactLeadSlice";
import { useSelector } from "react-redux";
import { fetchModuleData } from "common/redux/reducers/dynamicModuleSlice";
import SearchSelect from "common/components/autoComplete/AutoCompleteSelect";

const EditMeeting = (props) => {
  const {
    onClose,
    isOpen,
    moduleId,
    setAction,
    meetingData,
    viewMode = false,
    permission,
    setViewMode,
    provideFormikConfig = () => { }

  } = props;
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [contactModelOpen, setContactModel] = useState(false);
  const [leadModelOpen, setLeadModel] = useState(false);
  const [meetingsData, setMeetingsData] = useState(null);
  const user = JSON.parse(localStorage.getItem("user"));
  const meeting = meetingData;
  const formattedDateTime = formatTimestamp(meeting?.timestamp);
  const [relatedContacts, setRelatedContacts] = useState([]);

  const { formik } = props;
  function setMeetingData() {
    const resData = {
      agenda: meeting?.agenda || "",
      location: meeting?.location || "",
      related: meeting?.related || "",
      dateTime: formattedDateTime || "",
      notes: meeting?.notes || "",
      createdBy: user?._id,
      attendes: meeting?.attendes?.map((attendee) => attendee._id) || [],
      attendesLead:
        meeting?.attendesLead?.map((attendee) => attendee._id) || "",
      startDate: meeting?.startDate || convertUtcToIst(new Date()),
      endDate: meeting?.endDate || "",
      attendesAccount: meeting?.attendesAccount?.[0]?._id || "",
      attendesDeal: meeting?.attendesDeal?.[0]?._id || "",
      status: meeting?.status || crmConstant.scheduled,
    };
    const config = {
      initialValues: resData,
      validationSchema: EditMeetingSchema,
      onSubmit: (values, { resetForm }) => {
        updateData(values);
      },
    };
    provideFormikConfig(config);
    formik.setValues(resData);
    setMeetingsData(resData);
  }

  const contactData = useSelector((state) => state.contactLead.contacts);
  const leadData = useSelector((state) => state.contactLead.leads);
  const dynamicModules = useSelector((state) => state.dynamicModule.modules);
  const [list, setList] = useState({
    contact: contactData,
    lead: leadData,
    account: dynamicModules?.account?.data,
    deal: dynamicModules?.deal?.data,
  });
  useEffect(() => {
    setList((prev) => ({
      ...prev,
      contact: contactData || [],
      lead: leadData || [],
      account: dynamicModules?.account?.data || [],
      deal: dynamicModules?.deal?.data || [],
    }));
  }, [contactData, leadData, dynamicModules]);
  useEffect(() => {
    if (
      formik.values?.attendes?.length > 0 &&
      (formik.values.related === "Account" ||
        formik.values.related === "Deal") &&
      list.contact?.length > 0
    ) {
      const contactIds = formik.values.attendes;

      const matchedContacts = list.contact
        .filter((contact) => contactIds.includes(contact._id))
        .map((contact) => ({
          value: contact._id,
          label: contact.contactName || "-",
        }));
       if(viewMode){
        setRelatedContacts(matchedContacts);
      }
    } else {
      setRelatedContacts([]);
    }
  }, [formik.values.attendes, formik.values.related, list.contact]);
  const dispatch = useDispatch()
  async function getContactListData() {
    dispatch(getContactList({ fetchAllData: true }))
  }

  async function getLeadListData() {
    dispatch(getLeadList({ fetchAllData: true }))
  }
  const fetchAllData = () => {
    try {
      let result = [];

      if (values.related === "Contact" && list.contact) {
        result = list.contact.map((item) => ({
          value: item._id ?? "",
          label: `${item?.contactName ?? "-"}`,
        }));
      } else if (values.related === "Lead" && list.lead) {
        result = list.lead.map((item) => ({
          value: item?._id ?? "",
          label: item.leadName ?? "",
        }));
      } else if (values.related === constant.account && list.account) {
        result = list.account.map((account) => ({
          value: account._id,
          label: account.accountName,
          contacts: account.contact ?? [],
        }));
      } else if (values.related === constant.deal && list.deal) {
        result = list.deal.map((item) => ({
          value: item?._id ?? "",
          label: item.dealName ?? "",
          contacts: item.contact ?? [],
        }));
      }

      setData(result);
    } catch (e) {
      console.error("Error fetching all data:", e); // Log error for debugging
      toast.error(constant.somethingWrong);
    }
  };
  const fetchDynamicData = async (id, type) => {
    await dispatch(fetchModuleData({ moduleId: id, fetchAllData: true, type: type }));

  };
  const fetchCustomDataFields = async (type) => {
    const result = await getApi(`api/custom-field/?moduleName=${type}`);
    const singaleData = result?.data?.find((item) => item?.moduleName === type);
    fetchDynamicData(singaleData?._id, type === "Deals" ? "deal" : "account");
  };
  useEffect(() => {
    getContactListData();
    getLeadListData();
    setMeetingData();
    fetchCustomDataFields("Deals");
    fetchCustomDataFields("Accounts");
  }, []); // Re-run effect when isOpen changes

  const {
    errors,
    touched,
    values,
    handleBlur,
    handleChange,
    handleSubmit,
    setFieldValue,
  } = formik;
  useEffect(() => {
    fetchAllData();
  }, [list, values.related]);
  const updateData = async (values) => {
    try {
      setIsLoading(true);

      const normalize = (input) => {
        if (Array.isArray(input)) {
          return input
            .map((item) =>
              typeof item === "object" && item !== null
                ? item.value || item._id
                : item
            )
            .filter(Boolean);
        }
        if (typeof input === "object" && input !== null) {
          return input._id || input.value || "";
        }
        return input;
      };

      const rawUpdatedValues = {
        ...values,
        attendes: normalize(values.attendes),
        attendesLead: normalize(values.attendesLead),
        attendesAccount: normalize(values.attendesAccount),
        attendesDeal: normalize(values.attendesDeal),
      };

      const cleanedValues = Object.fromEntries(
        Object.entries(rawUpdatedValues).filter(
          ([_, v]) =>
            v !== undefined &&
            v !== null &&
            v !== "" &&
            !(Array.isArray(v) && v.length === 0)
        )
      );

      const response = await putApi(
        `api/meeting/edit/${moduleId}`,
        cleanedValues
      );

      if (response.status === 200) {
        props.getData?.();
        setAction((prev) => !prev);
        toast.success(crmConstant.meetingSuccess.replace("added", "updated"));
      }
    } catch (e) {
      toast.error(constant.somethingWrong);
    } finally {
      setIsLoading(false);
    }
  };

  function onChangeHandler(e) {
    if (e.target.value.startsWith(" ")) {
      return;
    }
    handleChange(e);
  }

  useEffect(() => {
    const selected =
      values.related === "Contact"
        ? values.attendes
        : values.related === "Lead"
          ? values.attendesLead
          : values.related === constant.account
            ? values.attendesAccount
            : values.attendesDeal;

    const selectedArray = Array.isArray(selected) ? selected : [selected];

    const defaultSelectedItems = data.filter((item) =>
      selectedArray.includes(item.value)
    );

    console.log("🔹 Default Selected Items:", defaultSelectedItems);
  }, [values.related, values.attendes, values.attendesLead, values.attendesAccount, values.attendesDeal, data]);


  return (
    <Box className="manualFormContainer">
      <Box className="manualFormBody">
        {/* Contact Model  */}
        <MultiContactModel
          data={data}
          isOpen={contactModelOpen}
          onClose={setContactModel}
          fieldName="attendes"
          setFieldValue={setFieldValue}
        />
        {/* Lead Model  */}
        <MultiLeadModel
          data={data}
          isOpen={leadModelOpen}
          onClose={setLeadModel}
          fieldName="attendesLead"
          setFieldValue={setFieldValue}
        />

        <Grid templateColumns="repeat(12, 1fr)" gap={3}>
          <GridItem colSpan={{ base: 6 }}>
            <FormLabel
              display="flex"
              ms="4px"
              fontSize="sm"
              fontWeight="500"
              mb="8px"
            >
              {crmConstant.meetingName}
              <Text color={colors.red["500"]}>*</Text>
            </FormLabel>
            <Input
              disabled={viewMode}
              fontSize="sm"
              onChange={handleChange}
              onBlur={handleBlur}
              value={values.agenda}
              name="agenda"
              placeholder={crmConstant.meetingName}
              fontWeight="500"
              borderColor={errors.agenda && touched.agenda ? "red.300" : null}
            />
            <Text fontSize="sm" mb="10px" color={colors.red["500"]}>
              {" "}
              {errors.agenda && touched.agenda && errors.agenda}
            </Text>
          </GridItem>
          <GridItem colSpan={{ base: 12, md: 6 }}>
            <FormLabel
              display="flex"
              ms="4px"
              fontSize="sm"
              fontWeight="500"
              mb="8px"
            >
              {constant.dateAndTime}
              <Text color={colors.red["500"]}>*</Text>
            </FormLabel>
            <Input
              disabled={viewMode}
              type="datetime-local"
              fontSize="sm"
              onChange={(e) => {
                onChangeHandler(e);
              }}
              onBlur={handleBlur}
              value={values.startDate}
              name="startDate"
              fontWeight="500"
              borderColor={
                errors?.startDate && touched?.startDate ? "red.300" : null
              }
            />
            <Text mb="10px" fontSize="sm" color={colors.red["500"]}>
              {" "}
              {errors.startDate && touched.startDate && errors.startDate}
            </Text>
          </GridItem>

          <GridItem colSpan={{ base: 6 }}>
            <FormLabel
              display="flex"
              ms="4px"
              fontSize="sm"
              fontWeight="500"
              mb="8px"
            >
              {constant.locationLabel}
            </FormLabel>
            <Input
              disabled={viewMode}
              fontSize="sm"
              onChange={handleChange}
              onBlur={handleBlur}
              value={values.location}
              name="location"
              placeholder="Location"
              fontWeight="500"
              borderColor={
                errors.location && touched.location ? "red.300" : null
              }
            />
            <Text mb="10px" color={colors.red["500"]} fontSize="sm">
              {" "}
              {errors.location && touched.location && errors.location}
            </Text>
          </GridItem>

          <GridItem colSpan={{ base: 6 }}>
            <FormLabel
              display="flex"
              ms="4px"
              fontSize="sm"
              fontWeight="500"
              mb="8px"
            >
              {crmConstant.status}
            </FormLabel>
            <ChakraSelect
              disabled={viewMode}
              onChange={(e) => setFieldValue("status", e.target.value)}
              value={values.status}
            >
              <option value={crmConstant.scheduled}>
                {crmConstant.scheduled}
              </option>
              <option value={crmConstant.completed}>
                {crmConstant.completed}
              </option>
              <option value={crmConstant.cancelled}>
                {crmConstant.cancelled}
              </option>
            </ChakraSelect>
            <Text mb="10px" color={"red"} fontSize="sm">
              {errors.related && touched.related && errors.related}
            </Text>
          </GridItem>

          <GridItem colSpan={{ base: 6 }}>
            <FormLabel
              display="flex"
              ms="4px"
              fontSize="sm"
              fontWeight="500"
              mb="8px"
            >
              {crmConstant.related}
              <Text color={colors.red["500"]}>*</Text>
            </FormLabel>
            <ChakraSelect
              disabled={viewMode}
              onChange={(e) => {
                setFieldValue(crmConstant.relatedValue, e.target.value);
                setFieldValue("attendesAccount", "");
                setFieldValue("attendesDeal", "");
                setFieldValue("attendes", "");
                setFieldValue("attendesLead", "");
              }}
              value={values.related}
            >
              {props.related === "Contact" && (
                <option value="Contact">{crmConstant.contact}</option>
              )}
              {props.related === "Lead" && (
                <option value="Lead">{crmConstant.lead}</option>
              )}
              {!props.leadContect && (
                <>
                  <option value="Contact">{crmConstant.contact}</option>
                  <option value="Lead">{crmConstant.lead}</option>
                  <option value={constant.account}>{constant.account}</option>
                  <option value={constant.deal}>{constant.deal}</option>
                </>
              )}
            </ChakraSelect>
            <Text mb="10px" color={colors.red["500"]} fontSize="sm">
              {errors.related && touched.related && errors.related}
            </Text>
          </GridItem>
          {(values.related === constant.account ||
            values.related === constant.deal ||
            values.related === "Lead" ||
            values.related === "Contact") && (
              <GridItem colSpan={{ base: 6 }}>
                <FormLabel
                  display="flex"
                  ms="4px"
                  fontSize="sm"
                  fontWeight="500"
                  mb="8px"
                >
                  {crmConstant.preferredAssignee}{" "}
                  {values.related === constant.account
                    ? constant.account
                    : values.related === constant.deal
                      ? constant.deal
                      : values.related}
                  <Text color="red">*</Text>
                </FormLabel>

                {/* <Select
                  disabled={viewMode}
                  name={
                    values.related === "Contact"
                      ? "attendes"
                      : values.related === constant.account
                        ? "attendesAccount"
                        : values.related === constant.deal
                          ? "attendesDeal"
                          : "attendesLead"
                  }
                  value={(() => {
                    const selected =
                      values.related === "Contact"
                        ? values.attendes
                        : values.related === "Lead"
                          ? values.attendesLead
                          : values.related === constant.account
                            ? values.attendesAccount
                            : values.attendesDeal;

                    const selectedArray = Array.isArray(selected)
                      ? selected
                      : [selected];

                    return data.filter((item) =>
                      selectedArray.includes(item.value)
                    );
                  })()}
                  options={data}
                  placeholder="Assign To"
                  onChange={(selectedOption) => {
                    if (values.related === "Contact") {
                      setFieldValue("attendes", selectedOption?.value || "");
                    
                    } else if (values.related === "Lead") {
                      setFieldValue("attendesLead", selectedOption?.value || "");
                    } else if (values.related === constant.account) {
                      setFieldValue(
                        "attendesAccount",
                        selectedOption?.value || ""
                      );
                    } else if (values.related === constant.deal) {
                      setFieldValue("attendesDeal", selectedOption?.value || "");
                    }

                    const selectedValues = Array.isArray(selectedOption)
                      ? selectedOption.map((opt) => opt.value)
                      : [selectedOption?.value].filter(Boolean);

                    const selectedItems = data.filter((item) =>
                      selectedValues.includes(item.value)
                    );

                    const contactIds = selectedItems.flatMap(
                      (item) => item.contacts || []
                    );
                    const uniqueContactIds = [...new Set(contactIds)];

                    const matchedContacts = list.contact
                      ?.filter((c) => uniqueContactIds.includes(c._id))
                      .map((contact) => ({
                        value: contact._id,
                        label: contact.contactName || "-",
                      }));

                    setRelatedContacts(matchedContacts || []);
                  }}
                className={`basic-multi-select ${
                  viewMode ? "pointerNone" : ""
                    }`}
                  classNamePrefix="select"
                /> */}

                <SearchSelect
                  isMulti={values.related === "Contact" ? true : false}
                  disabled={viewMode}
                  name={(() => {
                    if (values.related === "Contact") return "attendes"
                    if (values.related === constant.account) return "attendesAccount"
                    if (values.related === constant.deal) return "attendesDeal"
                    return "attendesLead"
                  })()}
                  value={(() => {
                    const selected =
                      values.related === "Contact"
                        ? values.attendes
                        : values.related === "Lead"
                          ? values.attendesLead
                          : values.related === constant.account
                            ? values.attendesAccount
                            : values.attendesDeal

                    const selectedArray = Array.isArray(selected) ? selected : [selected]
                    const filteredData = data.filter((item) => selectedArray.includes(item.value))

                    console.log("Selected Array:", selectedArray)
                    console.log("Filtered Data:", filteredData[0]?.value)


                    return data.filter((item) => selectedArray.includes(item.value))
                  })()}
                  options={data}
                  placeholder="Assign To"
                  onSelect={({ name, value }) => {
                    const selectedValues = Array.isArray(value)
                      ? value.map((v) => (typeof v === "object" ? v.value : v))
                      : [typeof value === "object" ? value.value : value].filter(Boolean)

                    setFieldValue(name, selectedValues)

                    const selectedItems = data?.filter((item) => selectedValues.includes(item.value))

                    const contactIds = selectedItems?.flatMap((item) => item?.contacts || [])
                    const uniqueContactIds = [...new Set(contactIds)]

                    const matchedContacts = list?.contact
                      ?.filter((contact) => uniqueContactIds.includes(contact._id))
                      .map((contact) => ({
                        value: contact._id,
                        label: contact.contactName || "-",
                      }))

                    setRelatedContacts(matchedContacts || [])
                  }}
                  className={`basic-multi-select ${viewMode ? "pointerNone" : ""}`}
                  isSearchable={true}
                />

                <Text color="red">
                  {values.related === "Contact"
                    ? errors.attendes && touched.attendes && errors.attendes
                    : values.related === constant.account
                      ? errors.attendesAccount &&
                      touched.attendesAccount &&
                      errors.attendesAccount
                      : values.related === constant.deal
                        ? errors.attendesDeal &&
                        touched.attendesDeal &&
                        errors.attendesDeal
                        : errors.attendesLead &&
                        touched.attendesLead &&
                        errors.attendesLead}
                </Text>
              </GridItem>
            )}

          {relatedContacts.length > 0 && (
            <GridItem colSpan={{ base: 6 }}>
              <FormLabel fontSize="sm" fontWeight="500" mb="8px">
                {constant.selectContacts} {values.related}
              </FormLabel>
              <Select
                isDisabled={viewMode}
                isMulti
                name="attendesContact"
                options={relatedContacts}
                placeholder="Select related contacts"
                value={relatedContacts.filter((item) =>
                  values.attendes?.includes(item.value)
                )}
                onChange={(selected) => {
                  const selectedContactIds = selected.map((item) => item.value);
                  setFieldValue("attendes", selectedContactIds);
                }}
                className={`basic-multi-select ${
                  viewMode ? "pointerNone" : ""
                  }`}
                classNamePrefix="select"
              />

              {/* <SearchSelect
                disabled={viewMode}
                isMulti
                placeholder="Select related contacts"
                name="attendesContact"
                options={relatedContacts}
                value={values.attendes} 
                onSelect={({ value: selectedValues }) => {
                  setFieldValue("attendes", selectedValues || []);
                }}
              /> */}
              <Text mb="10px" color="red" fontSize="sm">
                {errors.attendes && touched.attendes && errors.attendes}
              </Text>
            </GridItem>
          )}

          <GridItem colSpan={{ base: 12 }}>
            <FormLabel
              display="flex"
              ms="4px"
              fontSize="sm"
              fontWeight="500"
              mb="8px"
            >
              {crmConstant.description}
            </FormLabel>
            <Textarea
              disabled={viewMode}
              resize={"none"}
              fontSize="sm"
              placeholder={crmConstant.description}
              onChange={handleChange}
              onBlur={handleBlur}
              value={values.notes}
              name="notes"
              fontWeight="500"
              borderColor={errors.notes && touched.notes ? "red.300" : null}
            />
            <Text mb="10px" color={colors.red["500"]}>
              {" "}
              {errors.notes && touched.notes && errors.notes}
            </Text>
          </GridItem>
        </Grid>
      </Box>
      {/* <Flex className="manualFormFooter">
        {viewMode ? (
          (user.role === "superAdmin" || permission?.update) && (
            <Button
              disabled={isLoading}
              onClick={() => setViewMode(false)}
              className="viewEditBtn"
            >
              <Image src={WhiteEditIcon} alt="edit" h={"16px"} w={"16px"} />
              {constant.edit}
            </Button>
          )
        ) : (
          <Flex gap={"16px"}>
            <Button
              sx={{ textTransform: "capitalize" }}
              onClick={() => {
                setViewMode(true);
                formik.setValues(meetingsData);
              }}
              variant="outline"
              className="cancelBtn theme-btn2"
              size="sm"
            >
              {constant.cancel}
            </Button>

            <Button
              sx={{ textTransform: "capitalize" }}
              type="submit"
              disabled={isLoading || !formik.isValid || !formik.dirty}
              onClick={handleSubmit}
              className="viewEditBtn"
            >
              {constant.upload}
            </Button>
          </Flex>
        )}
      </Flex> */}
    </Box>
  );
};

export default EditMeeting;
